import { apiPost } from '@/lib/api/client';
import type { LoginResponse } from '../types';

export async function loginApi(username: string, password: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/login', { username, password });
}

export async function logoutApi(): Promise<void> {
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('user');
}

export async function refreshTokenApi(refreshToken: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/refresh-token', { token: refreshToken });
}

export async function updatePasswordApi(
  userId: string,
  oldPassword: string,
  newPassword: string,
  confirmPassword: string
): Promise<void> {
  await apiPost('/auth/update-password', {
    userId,
    oldPassword,
    newPassword,
    confirmPassword,
  });
}
